import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { App } from './App';
import { PaymentConfirmation } from './pages/PaymentConfirmation';
import { GoogleTagManager } from './components/GoogleTagManager';
export function AppRouter() {
  return <HelmetProvider data-id="element-10">
      <BrowserRouter data-id="element-11">
        <GoogleTagManager data-id="element-12" />
        <Routes data-id="element-13">
          <Route path="/" element={<App data-id="element-15" />} data-id="element-14" />
          <Route path="/pago-confirmado" element={<PaymentConfirmation data-id="element-17" />} data-id="element-16" />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>;
}